import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import ContactCTA from './components/ContactCTA';

const ContactConsultation = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Contact Us | Get Expert Engineering Consultation | VASTECH</title>
        <meta
          name="description"
          content="Connect with VASTECH's engineering team for professional elevator solutions, AC maintenance, and smart building consultations in the UAE."
        />
        <meta
          name="keywords"
          content="contact vastech, engineering consultation, elevator service UAE, HVAC maintenance contact, smart home inquiry"
        />
        <meta property="og:title" content="Contact VASTECH | Engineering Excellence" />
        <meta
          property="og:description"
          content="Reach out to our expert team for professional consultation, emergency services, or project inquiries."
        />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://vastech.ae/contact-consultation" />
      </Helmet>

      <div className="min-h-screen bg-white text-slate-900 font-sans selection:bg-[#91756A]/30">
        <Header />

        <main className="relative">
          {/* Contact Hero */}
          <ContactHero />

          <section className="py-24 bg-white">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
              <div className="grid lg:grid-cols-12 gap-20">
                {/* Contact Information */}
                <div className="lg:col-span-5">
                  <ContactInfo />
                </div>

                {/* Contact Form */}
                <div className="lg:col-span-7">
                  <ContactForm />
                </div>
              </div>
            </div>
          </section>

          {/* Final CTA / Map Area */}
          <ContactCTA />
        </main>

        {/* Minimalistic Footer */}
        <Footer />
      </div>
    </>
  );
};

export default ContactConsultation;